<template>
  <footer class="footer px-2 pb-0 pt-3 bg-white mb-sm-a3">
    <p class="text-center size-12 pb-4 mb-0">{{ currentYear }} Copyright 社内SE転職ナビ</p>
  </footer>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<style scoped></style>
